import React, { useState } from 'react';
import './Accordion.css';
import { useTranslation } from 'react-i18next';
import oftaial_taurin from '../assets/oftaial_taurin.png';
import oftaial_hijaluronat from '../assets/oftaial_hijaluronat.png';
import oftaial_benefit_1 from '../assets/oftaial_benefit_1.png';
import oftaial_benefit_2 from '../assets/oftaial_benefit_2.png';
import oftaial_benefit_3 from '../assets/oftaial_benefit_3.png';
import oftaial_benefit_4 from '../assets/oftaial_benefit_4.png';
import oftaial from '../assets/oftaial.png';
import alfaLogo from '../assets/AlfaIntes.svg';

const Bullet = ({ children, highlight }) => (
  <p className={`compound-list__item${highlight ? ' compound-list__item--highlight' : ''}`}>
    <span className="compound-list__dot" aria-hidden="true" />
    <span>{children}</span>
  </p>
);

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`accordion-item${isOpen ? ' is-open' : ''}`}>
      <button
        className="accordion-header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        type="button"
      >
        <span className="accordion-header__title">{title}</span>
        <span className="accordion-header__icon" aria-hidden="true">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      {isOpen && <div className="accordion-content">{content}</div>}
    </div>
  );
};

const OftaialAccordion = () => {
  const [t] = useTranslation('global');

  return (
    <div className="accordion">
      <AccordionItem
        title={t('oftaial.accordianTitle_1')}
        content={
          <div className="compound-stack">
            <div className="compound-row">
              <div className="compound-block">
                <p className="compound-title">{t('oftaial.accordianTitle_1_naslov_1')}</p>
                <div className="compound-list">
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_1_b_1')}</Bullet>
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_1_b_2')}</Bullet>
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_1_b_3')}</Bullet>
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_1_b_4')}</Bullet>
                </div>
              </div>
              <div className="compound-formula">
                <img src={oftaial_taurin} alt={t('oftaial.accordianopisSlike_1')} />
              </div>
            </div>
            <div className="compound-row">
              <div className="compound-block">
                <p className="compound-title compound-title--accent">
                  {t('oftaial.accordianTitle_1_naslov_2')}
                </p>
                <div className="compound-list">
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_2_b_1')}</Bullet>
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_2_b_2')}</Bullet>
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_2_b_3')}</Bullet>
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_2_b_4')}</Bullet>
                  <Bullet>{t('oftaial.accordianTitle_1_naslov_2_b_5')}</Bullet>
                </div>
              </div>
              <div className="compound-formula">
                <img
                  src={oftaial_hijaluronat}
                  alt={t('oftaial.accordianopisSlike_1')}
                />
              </div>
            </div>
          </div>
        }
      />
      <AccordionItem
        title={t('oftaial.accordianTitle_2')}
        content={
          <div className="benefits-grid">
            <div className="benefits">
              <img src={oftaial_benefit_1} alt={t('oftaial.accordianopisSlike_1')} />
              <p>{t('oftaial.benefit_1')}</p>
            </div>
            <div className="benefits">
              <img src={oftaial_benefit_2} alt={t('oftaial.accordianopisSlike_2')} />
              <p>{t('oftaial.benefit_2')}</p>
            </div>
            <div className="benefits">
              <img src={oftaial_benefit_3} alt={t('oftaial.accordianopisSlike_3')} />
              <p>{t('oftaial.benefit_3')}</p>
            </div>
            <div className="benefits">
              <img src={oftaial_benefit_4} alt={t('oftaial.accordianopisSlike_4')} />
              <p>{t('oftaial.benefit_4')}</p>
            </div>
          </div>
        }
      />
      <AccordionItem
        title={t('oftaial.accordianTitle_3')}
        content={
          <div className="accordionList">
            <p className="lead">{t('oftaial.accordianText_3')}</p>
            <p className="sublead">{t('oftaial.accordianText_3_sub')}</p>
            <div className="compound-list">
              <Bullet>{t('oftaial.bullet_1')}</Bullet>
              <Bullet>{t('oftaial.bullet_2')}</Bullet>
              <Bullet>{t('oftaial.bullet_3')}</Bullet>
              <Bullet>{t('oftaial.bullet_4')}</Bullet>
              <Bullet>{t('oftaial.bullet_5')}</Bullet>
              <Bullet>{t('oftaial.bullet_6')}</Bullet>
            </div>
          </div>
        }
      />
      <AccordionItem
        title={t('oftaial.accordianTitle_4')}
        content={
          <div className="accordionText">
            <div className="accordianlogo">
              <ul>
                <li>
                  <span>{t('idroflog.doziranje_label')}</span>
                  {t('oftaial.doziranje')}
                </li>
                <li>
                  <span>{t('idroflog.pakovanje_label')}</span>
                  {t('oftaial.pakovanje')}
                </li>
                <li>
                  <span>{t('oftaial.sadrzi')}</span>
                </li>
                <li>
                  <span>{t('oftaial.kompatibilnost')}</span>
                </li>
                <li>
                  <span>{t('idroflog.proizvodjac_label')}</span>
                  {t('oftaial.proizvodjac')}
                </li>
              </ul>
              <img src={alfaLogo} alt={t('oftaial.accordianopisSlike_1')} />
            </div>
            <div className="proizvod">
              <img src={oftaial} alt={t('oftaial.accordianopisSlike_1')} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default OftaialAccordion;
